import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-layout',
  templateUrl: './edit-layout.component.html',
  styleUrls: ['./edit-layout.component.css']
})
export class EditLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
